(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('SqFtCalc', () => ({
      cache: {},
      config: {
        ht: '',
        wd: '',
        sqft_per_panel: 0
      },
      results: {
        area: 0,
        panels: 0
      },
      variants: [],
      flags: {
      },
      init() {
        let am = this;
        am.InitSelf()
        am.$watch('config', am.Calculate.bind(am));

        am.$watch('results.panels', () => {
          let qty = am.results.panels || 1;
          // console.log(qty)
          document.dispatchEvent(new CustomEvent('set:qty', { detail: {qty} }))
        })

        document.addEventListener('product:variant-change', (e) => {
          // console.log(e);
          let variant = am.variants.find(v => v.id == e.detail.variant.id);
          am.config.sqft_per_panel = variant.sqft_per_panel;
        });
      },
      InitSelf() {
        let am = this;
        am.cache.$product = document.querySelector('.product__grid');
        am.config.sqft_per_panel = am.$el.dataset.sqft_per_panel;
        am.variants = JSON.parse(am.$el.dataset.variants);
      },
      Calculate() {
        let am = this;
        let ht = parseFloat(am.config.ht) || 0
        let wd = parseFloat(am.config.wd) || 0
        let area = parseFloat((ht * wd).toFixed(2))
        am.results.area = area
        am.results.panels = Math.ceil(area / parseFloat(am.config.sqft_per_panel))
        // console.log(area)
      },
      async e_AddToCart() {
        let am = this;
        if (am.results.area == 0) return;
        
        let variant_id = am.cache.$product.querySelector('.variant-selector__variants').value
        let items_to_add = [{
          id: variant_id,
          quantity: am.results.panels
        }]

        await s_utils.AddItemsToCart(items_to_add)
        s_utils.RefreshCart()
      }
    }));
  
    Alpine.data('ProductQty', () => ({
      cache: {},
      qty: 1,
      init() {
        let am = this;
        am.InitSelf()
      },
      InitSelf() {
        let am = this;
        am.cache.$qty = am.$el.querySelector('[name="quantity"]')

        am.$el.addEventListener('click', am.QtyUpdated.bind(am))
        am.$el.addEventListener('change', am.QtyUpdated.bind(am))

        am.$watch('qty', () => {
          let qty = am.qty
          document.dispatchEvent(new CustomEvent('qty:updated', { detail: {qty} }));
        });

        document.addEventListener('set:qty', (e) => {
          // console.log(e)
          let qty = e.detail.qty
          am.cache.$qty.value = qty
          document.dispatchEvent(new CustomEvent('qty:updated', { detail: {qty} }));
        });
      },
      QtyUpdated(e) {
        // console.log(e)
        let am = this;
        let qty = parseInt(am.cache.$qty.value)
        if (qty == am.qty) return;
        am.qty = qty
      }
    }));

    Alpine.data('CoverageAreaByQuantity', () => ({
      sqft_per_panel: '',
      coverage: '',
      variants: [],
      qty: 1,
      init() {
        let am = this;
        am.InitSelf();
        am.$watch('sqft_per_panel', am.CalculateCoverage.bind(am));
        am.$watch('qty', am.CalculateCoverage.bind(am));

        document.addEventListener('qty:updated', (e) => {
          am.qty = e.detail.qty;
        });

        document.addEventListener('product:variant-change', (e) => {
          // console.log(e);
          let variant = am.variants.find(v => v.id == e.detail.variant.id);
          am.sqft_per_panel = variant.sqft_per_panel;
        });
      },
      InitSelf() {
        let am = this;
        am.sqft_per_panel = am.coverage = am.$el.dataset.sqft_per_panel;
        am.variants = JSON.parse(am.$el.dataset.variants);
      },
      CalculateCoverage() {
        let am = this;
        am.coverage = (am.qty * am.sqft_per_panel).toFixed(2);
      }
    }));
  })
})()
